import { useMemo, useState } from "react";

const useSipCalculator = () => {
    const [monthlyInvestment, setMonthlyInvestment] = useState(25000);
    const [rate, setRate] = useState(12);
    const [years, setYears] = useState(10);

    const nMonths = years * 12;

    const totalValue = useMemo(() => {
        const monthlyRate = Math.pow(1 + rate / 100, 1 / 12) - 1;
        if (monthlyRate === 0) return monthlyInvestment * nMonths;

        return (
            monthlyInvestment *
            ((Math.pow(1 + monthlyRate, nMonths) - 1) / monthlyRate) *
            (1 + monthlyRate)
        );
    }, [monthlyInvestment, rate, years]);

    const investedAmount = monthlyInvestment * nMonths;

    return {
        title: "SIP Calculator",

        inputs: [
            {
                label: "Monthly Investment",
                value: monthlyInvestment,
                setter: setMonthlyInvestment,
                min: 1000,
                max: 100000,
                step: 1000,
            },
            {
                label: "Expected Return Rate (p.a)",
                value: rate,
                setter: setRate,
                min: 1,
                max: 30,
                step: 0.5,
            },
            {
                label: "Time Period (Years)",
                value: years,
                setter: setYears,
                min: 1,
                max: 40,
                step: 1,
            },
        ],

        totalValue,
        investedAmount,
        estimatedReturns: totalValue - investedAmount,

        infoContent: {
            heading: "SIP Calculator – Systematic Investment Plan",
            description:
                "A Systematic Investment Plan (SIP) allows you to invest a fixed amount regularly in mutual funds. It helps build long-term wealth through disciplined investing and compounding.",

            subHeading1: "What is a SIP Calculator?",
            subContent1:
                "A SIP calculator estimates the future value of your monthly investments based on expected returns and investment duration.",

            subHeading2: "How It Works",
            subContent2:
                "It uses a compound interest formula to calculate the maturity value based on monthly investments and expected annual return.",

            formula: "M = P × ({[1 + i]^n – 1} / i) × (1 + i)",

            subHeading3: "Benefits",
            benefits: [
                "Helps plan long-term financial goals",
                "Shows total invested amount",
                "Estimates potential wealth gain",
                "Saves time compared to manual calculation",
            ],
        },

    };
};

export default useSipCalculator;